import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { FiltroRicercaAnagrafeDTO } from "@app/shared/dto/filtro-ricerca-anagrafeDTO";
import { FiltroRicercaAnagrafeVO } from "@app/shared/vo/gescor/filtro-ricerca-anagrafeVO";
import { MapperPaginazione } from "../mapper-paginazione";
import { MapperRicercaSoggetto } from "../anagrafe/mapper-ricerca-soggetto";
import { MapperRicercaRecapito } from "../anagrafe/mapper-ricerca-recapito";

@Injectable({
    providedIn: "root"
  })
export class MapperFiltroRicercaAnagrafe
  implements
    MapperInterface<FiltroRicercaAnagrafeDTO, FiltroRicercaAnagrafeVO> {
  constructor(
    private mapperRicercaSoggetto: MapperRicercaSoggetto,
    private mapperRicercaRecapito: MapperRicercaRecapito,
    private mapperPaginazione: MapperPaginazione
  ) {}

  convertVoToDto(
    filtroRicercaAnagrafeVO: FiltroRicercaAnagrafeVO
  ): FiltroRicercaAnagrafeDTO {
    console.log(
      "convertVoToDto filtroRicercaAnagrafeVO -> filtroRicercaAnagrafeDTO",
      filtroRicercaAnagrafeVO
    );
    const filtroRicercaAnagrafeDTO: FiltroRicercaAnagrafeDTO = new FiltroRicercaAnagrafeDTO();

    if (filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO.tipoSoggetto !== "") {
      filtroRicercaAnagrafeDTO.ricercaSoggetto = this.mapperRicercaSoggetto.convertVoToDto(
        filtroRicercaAnagrafeVO.filtroSoggettoAnagrafeVO
      );
    }
    if (
      filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.tipoRecapito !== "" ||
      filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idRecapito > 0 ||
      filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO.idSoggetto > 0
    ) {
      filtroRicercaAnagrafeDTO.ricercaRecapito = this.mapperRicercaRecapito.convertVoToDto(
        filtroRicercaAnagrafeVO.filtroRecapitoAnagrafeVO
      );
    }

    filtroRicercaAnagrafeDTO.paginazione = this.mapperPaginazione.convertVoToDto(
      filtroRicercaAnagrafeVO.paginazione
    );
    console.log(filtroRicercaAnagrafeDTO);
    return filtroRicercaAnagrafeDTO || new FiltroRicercaAnagrafeDTO();
  }
  convertDtoToVo(
    filtroRicercaAnagrafeDTO: FiltroRicercaAnagrafeDTO
  ): FiltroRicercaAnagrafeVO {
    throw new Error("Method not implemented.");
  }
  convertListVoToDto(
    filtroRicercaAnagrafeVOList: FiltroRicercaAnagrafeVO[]
  ): FiltroRicercaAnagrafeDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(
    filtroRicercaAnagrafeDTOList: FiltroRicercaAnagrafeDTO[]
  ): FiltroRicercaAnagrafeVO[] {
    throw new Error("Method not implemented.");
  }
}
